
import Vue from 'vue'

export default Vue.extend({
   name: 'TextboxFormGroup',
   props: {
      id: String,
      label: String,
      value: String,
      name: { type: String, default: '' },
      placeholder: { type: String, default: '' },
      required: { type: Boolean, default: false },
      readonly: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
      validate: { type: Boolean, default: false },
      highlight: { type: Boolean, default: false },
      showLabel: { type: Boolean, default: true },
      showCharacterCount: { type: Boolean, default: false },
      instructions: { type: String, default: '' },
   },
   data() {
      return {
         initialValue: '',
         innerValue: '',
         dirty: false,
      }
   },
   computed: {
      validationFailed(): boolean {
         if (!this.required) {
            return false
         }
         if (!this.validate && !this.dirty) {
            return false
         }
         return !this.innerValue
      },
      showHighlight(): boolean {
         if (!this.highlight || !this.required) {
            return false
         }
         return !this.innerValue
      },
      helpBlock(): string {
         return `${this.label} is required`
      },
   },
   mounted() {
      this.innerValue = this.value
      this.initialValue = this.value
   },
   watch: {
      value(newValue: string) {
         if (newValue !== this.innerValue) {
            this.innerValue = newValue
            this.initialValue = newValue
         }
      },
   },
   methods: {
      raiseEvent(eventName: string) {
         if (!this.dirty) {
            this.dirty = this.innerValue !== this.value
         }
         this.$emit(eventName, this.innerValue)
      },
   },
   components: {},
})
